var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intent-pie-container"},[(_vm.loading)?_c('div',{staticClass:"loading-placeholder"},[_c('span',[_vm._v("加载中...")])]):(_vm.hasData)?_c('div',{ref:"chartRef",staticClass:"chart-container"}):_c('div',{staticClass:"no-data-placeholder"},[_c('span',[_vm._v("暂无数据")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }